import { useLocation } from "react-router-dom";
import { titleForPath } from "lib/adminNav";
import { useAuth } from "lib/auth";

export default function AdminTopbar() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const title = titleForPath(pathname);

  return (
    <div className="bg-white border-b border-[#e6e9ec] px-9 h-16 flex items-center justify-between sticky top-0 z-50">
      <div>
        <div className="font-serif text-xl font-bold text-green-dark">{title}</div>
        <div className="text-xs text-[#9aa]">Welcome back, {user?.name || "Admin"}</div>
      </div>

      <div className="flex items-center gap-[18px]">
        <div className="relative cursor-pointer text-xl">
          🔔
          <span className="absolute -top-1 -right-1.5 bg-red text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
            5
          </span>
        </div>
        <div className="text-xl cursor-pointer">✉️</div>
        <div className="flex items-center gap-2.5 pl-[18px] border-l border-[#e6e9ec]">
          <div className="w-[38px] h-[38px] rounded-full bg-green text-white flex items-center justify-center font-bold font-serif">
            {user?.initials || "AD"}
          </div>
          <div>
            <div className="text-[13px] font-semibold text-ink">{user?.name || "Admin"}</div>
            <div className="text-[11px] text-[#9aa]">{user?.role || "Administrator"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
